export default __webpack_public_path__ + "static/media/idatacourse_wechat.d552204f.jpg";